exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noty-content[data-v-9a6547f2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start;color:#5c5c5c}.noty-content[data-v-9a6547f2]:hover{color:#020000}.noty-avatar[data-v-9a6547f2]{width:30px}.noty-contact[data-v-9a6547f2]{padding:10px;width:100%;margin:3px}.read-at[data-v-9a6547f2]{background:#cbe8ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9a6547f2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Notification.vue
// module id = RCMh
// module chunks = 0